// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"a3bb3bbe","587":"ab20c446"}[chunkId] + ".chunk.js";
};